const _prefix = 'VEHICLE_FAVORITE_BUTTON::';

export const UPDATE_FAVORITE_FLAG = _prefix + 'UPDATE_FAVORITE_FLAG';
export const AD_IS_ADDED_TO_FAVORITES = _prefix + 'AD_IS_ADDED_TO_FAVORITES';

export const updateFavoriteFlag = ({estimateId, dataType, newValue}) => ({type: UPDATE_FAVORITE_FLAG, estimateId, dataType, newValue});
export const adIsAddedToFavorites = () => ({type: AD_IS_ADDED_TO_FAVORITES});